// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Px9z","rightAdornment":"Header_rightAdornment__NOWQE"};